import React, { Component, Fragment } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Col, Label, Input, Row } from 'reactstrap';
import { AvForm, AvGroup, AvInput } from 'availity-reactstrap-validation';
import { negativeIntegersValidation } from "../../../../utils/CommonUtils";
import MaterialIcon from 'material-icons-react';
import i18n from '../../../../i18next';
import TimeTableScreen from '../../../common/operationHours/TimeTableScreen';

class InStoreTypesModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            title: '',
            label: '',
            defaultMenuDraftDTO: null,
            inStorePrepTime: '',
            futureOrderEnabled: false,
            preparationTimes: [],
            timeSlots: []
        }

        this.changeState = this.changeState.bind(this);
        this.submitData = this.submitData.bind(this);
        this.renderMenuOptions = this.renderMenuOptions.bind(this);
        this.updatePrepTimesState = this.updatePrepTimesState.bind(this);
    }

    componentDidMount() {
        const { id, title, label, defaultMenuDraftDTO, inStorePrepTime, futureOrderEnabled, preparationTimes, timeSlots } = this.props.selectedType;
        if (this.props.isEdit) {
            this.setState({
                ...this.state,
                id: id,
                title: title,
                label: label,
                defaultMenuDraftDTO: defaultMenuDraftDTO,
                inStorePrepTime: inStorePrepTime,
                futureOrderEnabled: futureOrderEnabled,
                preparationTimes: preparationTimes,
                timeSlots: timeSlots
            });
        }
    }

    submitData() {
        if (this.props.isEdit) {
            this.props.changeInStoreTypes(this.state, 'edit', this.props.selectedTypeIndex)
        } else {
            this.props.changeInStoreTypes(this.state, 'create', this.props.selectedTypeIndex)
        }
        this.props.toggle(false, false, {}, null);
    }

    renderContent() {
        const { titleCol, labelStyle, noPadding } = styles;

        return (
            <Fragment>
                <AvGroup sm={12} style={titleCol}>
                    <Label sm={5} style={labelStyle}>{i18n.t('screens:restaurantsMainContainer.inStoreTitle')}</Label>
                    <Col sm={7} style={noPadding}>
                        <AvInput type="text" name="title"
                            placeholder={i18n.t('screens:restaurantsMainContainer.enterTitle')}
                            required={true}
                            value={this.state.title}
                            onChange={this.changeState}
                            maxLength={48} />
                    </Col>
                </AvGroup>
                <AvGroup sm={12} style={titleCol}>
                    <Label sm={5} style={labelStyle}>{i18n.t('screens:restaurantsMainContainer.inStoreLabel')}</Label>
                    <Col sm={7} style={noPadding}>
                        <AvInput
                            placeholder={i18n.t('screens:restaurantsMainContainer.enterLabel')}
                            type='text'
                            name='label'
                            required={true}
                            onChange={this.changeState}
                            value={this.state.label}
                            maxLength={48}>
                        </AvInput>
                    </Col>
                </AvGroup>
                <AvGroup sm={12} style={titleCol}>
                    <Label sm={5} style={labelStyle}>{i18n.t('screens:restaurantsMainContainer.defaultMenu')}</Label>
                    <Col sm={7} style={noPadding}>
                        <AvInput
                            type='select'
                            name='defaultMenuDraftDTO'
                            required={false}
                            onChange={this.changeState}
                            value={this.state.defaultMenuDraftDTO ? this.state.defaultMenuDraftDTO.id : this.state.defaultMenuDraftDTO}>
                            <option value=''>{i18n.t('screens:restaurantsMainContainer.selectMenu')}</option>
                            {this.renderMenuOptions()}
                        </AvInput>
                    </Col>
                </AvGroup>
                <AvGroup sm={12} style={titleCol}>
                    <Label sm={5} style={labelStyle}>{i18n.t('screens:restaurantsMainContainer.preparationTime')}</Label>
                    <Col sm={7} style={noPadding}>
                        <AvInput
                            className="inputPrepTime"
                            placeholder={`0${i18n.t('screens:restaurantsMainContainer.minutes')}`}
                            type='number'
                            name='inStorePrepTime'
                            required={true}
                            onChange={this.changeState}
                            value={this.state.inStorePrepTime}
                            maxLength={48}
                            onKeyPress={(e) => negativeIntegersValidation(e)}
                            min={1}
                        >
                        </AvInput>
                    </Col>
                </AvGroup>
            </Fragment>
        );
    }

    renderFutureOrders() {
        const { titleCol, labelStyle, noPadding, paragraph } = styles;
        
        return (
            <Fragment>
                <AvGroup sm={12} style={titleCol}>
                    <Label sm={5} style={labelStyle}>{i18n.t('screens:restaurantsMainContainer.enableFutureOrders')}</Label>
                    <Col sm={7} style={noPadding}>
                        <Input
                            type='checkbox'
                            name='futureOrderEnabled'
                            id='futureOrderEnabled'
                            style={styles.checkboxInput}
                            onChange={this.changeState}
                            checked={this.state.futureOrderEnabled}
                        >
                        </Input>
                    </Col>
                </AvGroup>
                {
                    this.state.futureOrderEnabled &&
                    <Fragment>
                        <TimeTableScreen
                            timeSlotBased={this.props.timeSlotBased}
                            preparationTimes={this.props.timeSlotBased ? this.state.timeSlots : this.state.preparationTimes}
                            updatePrepTimes={this.updatePrepTimesState}
                            readOnly={false}
                        />
                        <Row>
                            <div style={{ padding: '0 0 0 20px', width: 'calc(100% - 200px)' }}>
                                <p style={paragraph}>{i18n.t('common:deliveryCollectionDineInCurbside.timeFormat')}</p>
                                <p style={paragraph}>{i18n.t('common:deliveryCollectionDineInCurbside.nonStopWorkingTime')}</p>
                                <p style={paragraph}>{i18n.t('common:deliveryCollectionDineInCurbside.workingAfterMidnightTime')}</p>
                                <p style={paragraph}>{i18n.t('common:deliveryCollectionDineInCurbside.breakTimesAfterMidnight')}</p>
                            </div>
                        </Row>
                    </Fragment>
                }
            </Fragment>
        )
    }

    renderMenuOptions() {
        return this.props.menus.map(menu => {
            return (
                <option key={menu.id} value={menu.id}>{menu.name}</option>
            )
        })
    }

    changeState({ target }) {
        if (target.name === 'defaultMenuDraftDTO') {
            if (target.value) {
                this.setState({
                    ...this.state,
                    [target.name]: {
                        id: target.value,
                        name: target.options[target.selectedIndex].text
                    }
                })
            } else {
                this.setState({
                    ...this.state,
                    [target.name]: null
                })
            }

        } else {
            if (target.name === 'futureOrderEnabled') {
                this.setState({
                    ...this.state,
                    [target.name]: target.checked
                });
            } else {
                this.setState({
                    ...this.state,
                    [target.name]: target.value
                });
            }
        }
    }

    updatePrepTimesState(prepTimes, showErrorMsg) {
        if (this.props.timeSlotBased) {
            this.setState({
                preparationTimes: [],
                timeSlots: prepTimes,
            });
        } else {
            let newPrepTimes = prepTimes.map((prepTime) => {
                let { maxOrders, maxValue, duration, ...rest } = prepTime;
                return rest; 
            })

            this.setState({
                preparationTimes: newPrepTimes,
                timeSlots: [],
            });
        }
    }

    render() {
        const isApplyBtnDisabled = this.state.title === '' || this.state.label === '' || (this.state.inStorePrepTime === '' || this.state.inStorePrepTime === '0');

        return (
            <Modal className={this.props.timeSlotBased ? 'dinePayTimeSlotsTypesModal' : 'dinePayTypesModal'} isOpen={this.props.isOpen} toggle={() => this.props.toggle(false, false, {}, null)}>
                <ModalHeader className="modalHeader" toggle={() => this.props.toggle(false, false, {}, null)}>{i18n.t('screens:restaurantsMainContainer.addInStoreType')}</ModalHeader>
                <ModalBody>
                    <AvForm>
                        {this.renderContent()}
                    </AvForm>
                    {this.renderFutureOrders()}
                </ModalBody>

                <ModalFooter>
                    {
                        this.props.isEdit ?
                            <Button
                                color="primary" outline style={{ display: 'flex', alignItems: 'center' }}
                                onClick={() => {
                                    this.props.changeInStoreTypes(this.state, 'delete', this.props.selectedTypeIndex);
                                    this.props.toggle(false, false, {}, null);
                                }}>
                                <span style={{ marginBottom: 1 }}>
                                    <MaterialIcon icon="delete" color="#0288D1" size={18} />
                                </span>
                                {i18n.t('common:buttons.delete')}
                            </Button> : null
                    }
                    <Button color="primary" onClick={this.submitData} disabled={isApplyBtnDisabled}>
                        <MaterialIcon icon="check" color="#fff" size={20} />&nbsp;{i18n.t('common:buttons.apply')}
                    </Button>
                </ModalFooter>
            </Modal>
        );
    }
}

export default InStoreTypesModal;

let styles = {
    titleCol: {
        display: 'flex',
        justifyContent: 'flex-start'
    },
    labelStyle: {
        padding: '12px 16px 12px 0px'
    },
    noPadding: {
        padding: 0
    },
    checkboxInput: {
        position: "relative",
        margin: '0px 0px 0px 0px',
        top: 13
    },
    paragraph: {
        fontSize: 10,
        display: "flex",
        justifyContent: 'flex-end',
        marginBottom: 5
    },
}


// WEBPACK FOOTER //
// ./src/components/restaurants/settings/service/InStoreTypesModal.js